import { HttpClient } from '@angular/common/http';
import { Injectable, } from '@angular/core';
import { HttpService } from 'src/app/modules/shared/services/http.service';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class SharedCRMConfigService {

  constructor(
    private http: HttpClient,
    private httpService: HttpService) { }

  getEmailMapping(moduleId: number) {
    return this.http.get<any>(`${environment.apiUrl}EmailToTicketConfig?moduleId=${moduleId}`)
  }

  addEmailMapping(moduleId: number, data) {
    return this.http.post<any>(`${environment.apiUrl}ClosedReason/AddOrUpdateUnresolvedReason?moduleId=${moduleId}`, data)
      .toPromise()
      .then((res) => res);
  }

  addEditEmailMapping(moduleId: number, data) {
    return this.http.put<any>(`${environment.apiUrl}EmailToTicketConfig/ChannelMapper?moduleId=${moduleId}`, data)
      .toPromise()
      .then((res) => res);
  }

  deleteEmailMapping(moduleId: number, channelId) {
    return this.http.delete<any>(`${environment.apiUrl}EmailToTicketConfig/ChannelMapper?moduleId=${moduleId}&channelId=${channelId}`)
      .toPromise()
      .then((res) => res);
  }

  getTemplateFormFields(moduleId: number, channelId: number,isChildTemplate?:boolean) {
    if(isChildTemplate){
      return this.httpService.getById(`${environment.configUrlV2}/Template/SectionFieldsForFormBuild/Module/${moduleId}/Channel/${channelId}?isChildTemplate=${isChildTemplate}`);
    }
    else{
      return this.httpService.getById(`${environment.configUrlV2}/Template/SectionFieldsForFormBuild/Module/${moduleId}/Channel/${channelId}`);
    }
  }

  getTemplateImportFields(moduleId: number, channelId: number) {
    return this.http.get(`${environment.configUrlV2}/Template/SectionFieldsForImport/Module/${moduleId}/Channel/${channelId}`);
  }

  getContactConfigurations() {
    return this.http.get<any>(`${environment.configUrl}Configuration/ConfigurationsByModuleName?name=Contact`)
  }
}
